import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';

export const loggedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggingOut()) {
    return true;
  }

  if (!authService.isLoggedIn()) {
    return true;
  } else {
    
    router.navigate(['/home/products/manage']);
    return false;
  }
};
